import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { ANNUAL_REPORT_API } from "./apiRoutes";

interface UseGetAnnualReportingListProps {
  queryParams?: Omit<UseQueryOptions, "queryKey" | "queryFn">;
  applicableCompany: string | undefined;
}

// ✅ Accept applicableCompany as argument
const getAnnualReportingList = async (applicableCompany: string | undefined) => {
  return axiosAuth.get(
    `${ANNUAL_REPORT_API}/?applicableCompany=${applicableCompany ?? ""}`
  );
};

const useGetAnnualReportingList = ({
  queryParams,
  applicableCompany,
}: UseGetAnnualReportingListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["annual-reporting", applicableCompany], // 👈 Add dependency
    queryFn: () => getAnnualReportingList(applicableCompany),
    select: (data: any) => data.data,
    enabled: !!applicableCompany, // 👈 Prevent API call if undefined
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetAnnualReportingList;
